import React, { useState, Component, useRef } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import authService from '../api-authorization/AuthorizeService'
import debounce from 'lodash.debounce';


export class VaporesSemanalesView extends Component {
    constructor(props) {
        super(props);
        var rawUrl = window.location.toString();
        var semana_Id = rawUrl.split("Semanas/")[1].split("/")[0];
        this.state = {
            operation: props.operation,
            navieras: [],
            barcos: []
        };
        if (props.data) {
            this.state.model = props.data
            this.state.model.fecha = new Date(this.state.model.fecha).toISOString().substring(0, 10);
        }
        else {
            this.state.model = { semana_Id: semana_Id, naviera_Id: 0, barco_Id: 0, viaje: "", fecha: new Date().toISOString().substring(0, 10) };
        }
        console.log(" this.state.model", this.state.model)
        this.state.modelValidation = {
            semana_Id: this.state.model.semana_Id != 0,
            naviera_Id: this.state.model.naviera_Id != 0,
            barco_Id: this.state.model.barco_Id != 0,
            viaje: this.state.model.viaje != ""
        }
        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
        this.validate = debounce(this.validate, 1000)
        this.load_navieras = this.load_navieras.bind(this);
        this.load_barcos = this.load_barcos.bind(this);
        this.populateData = this.populateData.bind(this);
    }

    async handleChange(event) {

        var tempModel = this.state.model;
        tempModel[event.target.name] = event.target.value;
        this.setState({
            model: tempModel
        }, async () => {
            if (event.target.name == "naviera_Id") {
                this.setState({
                    barcos: await this.load_barcos()
                });
            }
            this.props.setModalBodyState(this.state).then(() => this.validate());
        });
        
    }
    async validate() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.state.model);
        const response = await fetch('api/vaporesSemanales/validate', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            var validations = await response.json();
            this.setState({
                modelValidation: validations
            }, () => {
                this.props.setModalBodyState(this.state);
            });
        }
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }
    
    render() {
        return (
            <div >
                <Row>
                    <Form>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="naviera_Id">
                                        <FormattedMessage id='Naviera' />
                                    </Label>
                                    <Input
                                        id="naviera_Id"
                                        name="naviera_Id"
                                        type="select"
                                        onChange={this.handleChange}
                                        value={this.state.model.naviera_Id}
                                        valid={this.getValidationValue(this.state.modelValidation.naviera_Id)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.naviera_Id)}
                                    >
                                        <option value="0"></option>
                                        {this.state.navieras.map(naviera => naviera.naviera_Id == this.state.model.naviera_Id ? (
                                            <option value={naviera.naviera_Id} selected>
                                                {naviera.nombre}
                                            </option>
                                        ) : (<option value={naviera.naviera_Id}>{naviera.nombre}</option>))}
                                    </Input>
                                    <FormFeedback>
                                        {this.state.model.naviera_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col></Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="barco_Id">
                                        <FormattedMessage id='Barco' />
                                    </Label>
                                    <Input
                                        id="barco_Id"
                                        name="barco_Id"
                                        type="select"
                                        onChange={this.handleChange}
                                        value={this.state.model.barco_Id}
                                        valid={this.getValidationValue(this.state.modelValidation.barco_Id)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.barco_Id)}
                                    >
                                        <option value="0"></option>
                                        {this.state.barcos.map(barco => barco.barco_Id == this.state.model.barco_Id ? (
                                            <option value={barco.barco_Id} selected>
                                                {barco.barcoInfo}
                                            </option>
                                        ) : (<option value={barco.barco_Id}>{barco.barcoInfo}</option>))}
                                    </Input>
                                    <FormFeedback>
                                        {this.state.model.barco_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="viaje">
                                        <FormattedMessage id='Viaje' />
                                    </Label>
                                    <FormattedMessage id='Viaje'>
                                        {(placeholder) =>
                                            <Input
                                                id="viaje"
                                                name="viaje"
                                                //placeholder={placeholder}
                                                type="text"
                                                onChange={this.handleChange}
                                                value={this.state.model.viaje}
                                                valid={this.getValidationValue(this.state.modelValidation.viaje)}
                                                invalid={!this.getValidationValue(this.state.modelValidation.viaje)}
                                            />
                                        }
                                    </FormattedMessage>
                                    <FormFeedback>
                                        {this.state.model.viaje == '' ? <FormattedMessage id='Este campo es requerido' /> : <FormattedMessage id='Este viaje ya esta siendo usado' />}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="fecha">
                                        <FormattedMessage id='Fecha' />
                                    </Label>
                                    <FormattedMessage id='Fecha'>
                                        {(placeholder) =>
                                            <Input
                                                id="fecha"
                                                name="fecha"
                                                //placeholder={placeholder}
                                                type="date"
                                                onChange={this.handleChange}
                                                value={this.state.model.fecha}
                                                valid={this.getValidationValue(this.state.modelValidation.fecha)}
                                                invalid={!this.getValidationValue(this.state.modelValidation.fecha)}
                                            />
                                        }
                                    </FormattedMessage>
                                    <FormFeedback>
                                        {this.state.model.fecha == '' ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            
                            
                        </Row>
                        
                        
                        
                        
                    </Form>
                </Row>
            </div>
        );
    }
    componentDidMount() {
        this.populateData();
    }
    async populateData() {
        this.setState({ loading: true, navieras: await this.load_navieras() },
            this.setState({ barcos: await this.load_barcos() })
        );
    }

    async load_navieras() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/navieras/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }

    async load_barcos() {
        if (this.state.model.naviera_Id != 0) {
            const token = await authService.getAccessToken();
            const response = await fetch('api/barcos?naviera_Id=' + this.state.model.naviera_Id, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            });
            const barcos = await response.json();

            // Sorting barcos array by pais, nombre, and puerto
            barcos.sort((a, b) => {
                // Compare pais
                if (a.pais < b.pais) return -1;
                if (a.pais > b.pais) return 1;

                // If pais are equal, compare nombre
                if (a.nombre < b.nombre) return -1;
                if (a.nombre > b.nombre) return 1;

                // If pais and nombre are equal, compare puerto
                if (a.puerto < b.puerto) return -1;
                if (a.puerto > b.puerto) return 1;

                return 0; // If pais, nombre, and puerto are all equal
            });

            return barcos;
        }
        else {
            return [];
        }
    }
}